exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quiz-section.quiz-useful-data .card-body{\n    height: calc(100vh - 210px) !important; \n}\n\n.quiz-section.quiz-useful-data{\n    margin-top: 0px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/online-mcq/instruction/instruction.component.css
// module id = ../../../../../src/app/online-mcq/instruction/instruction.component.css
// module chunks = common